import React from 'react';

import { useTranslation } from 'react-i18next';
import { Icon } from 'design-system-web';
import { ICON_SET_FONTAWESOME } from 'lane-shared/helpers/constants/icons';
import type { TemplateItem } from 'inspection-types';
import { S } from 'components/typography';

import { formatQuestionOrdinal } from '../../helpers/inspectionTemplateCustomizeHelpers';

import styles from './InspectionTemplateCustomizeSectionCard.scss';

type Props = {
  item: TemplateItem;
  sectionIndex: number;
  itemIndex: number;
  removeItemDisabledTitle: string;
};

export function Item({
  item,
  sectionIndex,
  itemIndex,
  removeItemDisabledTitle,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.itemRow}>
      <div className={styles.rowLead} aria-hidden />
      <S className={styles.itemText}>
        {formatQuestionOrdinal(sectionIndex, itemIndex)} {item.label}
      </S>
      <div className={styles.rowActionCell}>
        <button
          type="button"
          className={styles.rowActionButton}
          disabled
          title={removeItemDisabledTitle}
          aria-label={t('web.admin.inspections.templateCustomize.removeItemAria')}
        >
          <Icon name="trash-alt" set={ICON_SET_FONTAWESOME} type="far" />
        </button>
      </div>
    </div>
  );
}
